module.exports = __webpack_public_path__ + "img/0Q3A5798_FoamcoreMatted.2b729e42.jpg";